(function () {
  // This file is already loaded ONLY on the B2B page from theme.liquid,
  // so no need to check body classes.

  function isProductUrl(href) {
    if (!href) return false;

    // Handle relative, absolute, and links with query params
    try {
      const u = new URL(href, window.location.origin);
      return u.pathname.startsWith("/products/");
    } catch (e) {
      // Fallback for weird href formats
      return href.indexOf("/products/") === 0 || href.indexOf("/products/") > -1;
    }
  }

  function clickedInsideAllowedArea(target) {
    // Allow quick add, forms, buttons, variant pickers, etc.
    return !!target.closest(
      "button, form, input, select, textarea," +
        ".quick-add, .quick-add__submit, .quick-add__modal, .product-form," +
        "[data-quick-add], [data-open-quick-add], [data-product-form]"
    );
  }

  // 1) Block normal clicks that would open PDP
  document.addEventListener(
    "click",
    function (e) {
      const a = e.target.closest("a");
      if (!a) return;

      const href = a.getAttribute("href") || "";
      if (!isProductUrl(href)) return;

      // If user clicked quick add / form elements, don't block
      if (clickedInsideAllowedArea(e.target)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    },
    true
  );

  // 2) Also neutralize product links so middle-click / open-in-new-tab doesn’t go to PDP easily
  // (Not 100% foolproof, but helps a lot)
  function neutralizeLinks() {
    document.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      const href = a.getAttribute("href");
      if (!isProductUrl(href)) return;

      // Don't touch elements used by quick add modal triggers if any
      if (a.closest(".quick-add") || a.hasAttribute("data-quick-add")) return;

      a.setAttribute("data-b2b-original-href", href);
      a.setAttribute("href", "javascript:void(0)");
      a.style.cursor = "default";
    });
  }

  // Run once and also after any dynamic loads
  neutralizeLinks();

  const obs = new MutationObserver(function () {
    neutralizeLinks();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
